// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"481":"b7b5faae","884":"12de9a8b"}[chunkId] + ".css";
};